import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, forwardRef, Inject, Injector, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { take, map } from 'rxjs/operators';
import { BankCodeTypeService } from './bank-code-type.service';

@Pipe({
  name: 'bankCodeType',
  pure: false,
  standalone: false
})
export class BankCodeTypePipe implements PipeTransform, OnDestroy {
  private asyncPipe: AsyncPipe;

  constructor(
    @Inject(forwardRef(() => BankCodeTypeService)) private bankCodeTypeService: BankCodeTypeService,
    private injector: Injector
  ) {
    this.asyncPipe = new AsyncPipe(injector.get(ChangeDetectorRef));
  }

  ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  transform(value: string): string {
    return !value
      ? ''
      : this.asyncPipe.transform(
          this.bankCodeTypeService.bankCodeTypes$.pipe(
            take(1),
            map((classifiers) => classifiers.find((classifier) => classifier.id === value)?.label)
          )
        );
  }
}
